import { render, staticRenderFns } from "./dashboard-ignis-staff.vue?vue&type=template&id=0f12f8e8"
import script from "./dashboard-ignis-staff.vue?vue&type=script&lang=js"
export * from "./dashboard-ignis-staff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports